export default {
    ProformaBills: 'الفاتورة الأولية|الفواتير الأولية',
};
